import { ToolName } from '@debbie/common/dist/agents/index.js';
import { InteractionRecipient, } from '@debbie/common/dist/agents/tools/create-interaction.js';
import { InteractionType } from '@debbie/common/dist/interactions/index.js';
import { genObjectKey } from '@debbie/common/dist/util/index.js';
import * as api from '../api/agents.js';
import { createEntityCache } from '../invalidation.js';
import q from '../query.js';
export const agentProposalsEntity = 'agent-proposals';
export const agentProposalsCache = createEntityCache(agentProposalsEntity);
export const agentNoticesEntity = 'agent-notices';
export const agentNoticesCache = createEntityCache(agentNoticesEntity);
export const proposalsByCaseKey = (caseId) => `agent-proposals-by-case-${caseId}`;
export const useProposalHistoryByCase = (caseId) => q.query(`agent-proposal-history-by-case-${caseId}`, () => (caseId ? api.listProposalHistoryByCase(caseId) : null), agentProposalsCache.keys.collection, { enabled: caseId != null });
export const useProposalsByCase = (caseId) => q.query(proposalsByCaseKey(caseId), () => (caseId ? api.listProposalsByCase(caseId) : null), agentProposalsCache.keys.collection, { enabled: caseId != null });
export const agentNoticesByCaseKey = (caseId) => `agent-notices-by-case-${caseId}`;
export const useAgentNoticesByCase = (caseId) => q.query(agentNoticesByCaseKey(caseId), () => (caseId ? api.listAgentNoticesByCase(caseId) : null), agentNoticesCache.keys.collection, { enabled: caseId != null });
export const interactionProposalPreviewKey = (proposalId, edits) => `agent-proposal-preview-${proposalId}${edits ? `-${genObjectKey(edits)}` : ''}`;
export const useInteractionProposalPreview = (proposalId, edits) => q.query(interactionProposalPreviewKey(proposalId, edits), () => proposalId
    ? api.previewInteractionProposal(proposalId, edits ?? null)
    : null, agentProposalsCache.keys.item(proposalId), { enabled: proposalId != null });
export const proposalTitle = (toolName, proposedInput, lang) => {
    if (toolName === ToolName.CreateInteraction && proposedInput) {
        const input = proposedInput;
        const channel = lang.interactionTypes[input.type] ?? input.type;
        const recipient = input.recipient === InteractionRecipient.Debtor
            ? lang.agentProposalBodies.recipientDebtor
            : lang.agentProposalBodies.recipientCreditor;
        return `${channel} ${lang.agentProposalBodies.to} ${recipient}`;
    }
    if (toolName === ToolName.CreateCreditorMessage) {
        return lang.interactionTypes[InteractionType.ClientNote];
    }
    return lang.agentToolLabels[toolName] ?? toolName;
};
export const reasoningOf = (input) => {
    if (input && typeof input === 'object' && 'reasoning' in input) {
        const r = input.reasoning;
        return typeof r === 'string' && r.length > 0 ? r : null;
    }
    return null;
};
//# sourceMappingURL=index.js.map